"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
let lock = false;
class RemoveSplash extends React.Component {
    componentDidMount() {
        if (lock)
            return;
        lock = true;
        const splash = document.getElementById("mne-splash");
        if (!splash)
            return;
        // Blink screen if the page has loaded over a sat threshold (defined in css)
        // Measure this by checking if css animation countdown has been reached
        const splashCountdown = document.getElementById("mne-splash-countdown");
        if (splashCountdown && window.getComputedStyle(splashCountdown).opacity === "1") {
            // splash.style.backgroundColor = "#212121";
            splash.style.backgroundColor = "#000";
            // Blink the title
            const oldTitle = document.title;
            const newTitle = `(!) ${document.title}`;
            document.title = newTitle;
            setTimeout(() => {
                if (document.title === newTitle.trim()) {
                    document.title = oldTitle;
                }
            }, 200);
        }
        // Fade out
        splash.classList.add("mne-splash-available");
        setTimeout(() => {
            if (!splash.parentElement)
                return; // Make flow happy by null-checking
            splash.parentElement.removeChild(splash);
        }, 1000);
    }
    render() {
        return null;
    }
}
exports.default = RemoveSplash;
